import { render } from "./SchoolActivationClassesField.vue?vue&type=template&id=1fb47c9e&ts=true"
import script from "./SchoolActivationClassesField.vue?vue&type=script&lang=ts"
export * from "./SchoolActivationClassesField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__